import StickySidebar from "sticky-sidebar";

/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var sidebar = document.querySelector("#sticky-sidebar");

  if (sidebar) {
    new StickySidebar("#sticky-sidebar", {
      containerSelector: ".row-sticky",
      innerWrapperSelector: ".col-sidebar-inner",
      topSpacing: 20,
      bottomSpacing: 0,
      minWidth: 767,
    });
  }
});
